export default __webpack_public_path__ + "static/media/SWT1270.34I-35677_-20772_0.ac8c50f1.jpg";